import '../../less/entrypoints/post.less';

import { api } from '../services/api';
import { clearButtonLoading, setButtonLoading } from '../functions/events';
import { createAlert, removeAlerts } from '../functions/messages';

const commentForm = document.getElementById('comment-form');
const commentTextInput = document.getElementById('comment-form__text');
const commentAuthorInput = document.getElementById('comment-form__author');
const commentSubmitButton = document.getElementById('comment-form__submit');

commentForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    setButtonLoading(commentSubmitButton);
    removeAlerts(commentForm);

    const postId = commentForm.getAttribute('data-post-id');

    api
        .post(
            `/posts/${postId}/comments`,
            {
                text: commentTextInput.value,
                author: commentAuthorInput.value,
            },
        )
        .then((response) => {
            if (response.data && response.data.success) {

                // The page markup is:
                // .comments
                //   .c
                //   .c
                //   .c
                //   .c
                //     .comment-form
                // Insert the new comment before the .c containing the form.

                if (response.data.commentHtml) {
                    const commentContainer = commentForm.parentElement.parentElement;
                    const newComment = document.createElement('div');
                    newComment.innerHTML = response.data.commentHtml;
                    commentContainer.insertBefore(newComment.firstChild, commentForm.parentElement);
                } else {
                    const alert = createAlert('warning', response.data.message);
                    commentForm.append(alert);
                }

                // Keep the submit button disabled to prevent duplicate submissions.
                // Timeout so this happens after the finally.
                setTimeout(() => {
                    commentTextInput.value = '';
                    commentSubmitButton.disabled = true;
                }, 10);

                // Reset the form for another comment in 1 second.
                setTimeout(() => {
                    commentSubmitButton.disabled = false;
                }, 1000);
            }
        })
        .catch((err) => {
            const alert = createAlert('danger', err.message);
            commentForm.append(alert);
        })
        .finally(() => {
            clearButtonLoading(commentSubmitButton);
        });
});
